import $ from 'jquery';
import { capitalize } from 'lodash';

import { addToDataLayerForLinks } from './helper';

const smartBanner = {
    init() {
        $('.js-smart-banner-container').click((event) => {
            const { linkAction } = event.target.dataset;

            // It should prevent default anchor behavior in order to fire
            // GTM event. So, after the event being fired, it redirects to adjust
            addToDataLayerForLinks(event, {
                event: `smartbannerClicked_${capitalize(linkAction)}`
            });
        });

        return this;
    }
};

export function init() {
    return smartBanner.init();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/tracking/common/smartBanner.js
 **/